
import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachLopActionsObj } from "../../action-types/ke-hoach/IKeHoachLopActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachLopActions = {
  ...generateActions(eKeHoachLopActionsObj, "KE_HOACH_LOP"),
  ...generateActionForKey(eKeHoachLopActionsObj, "KE_HOACH_LOP", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Saved")
  }),
  ...generateActionForKey(eKeHoachLopActionsObj, "KE_HOACH_LOP", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Deleted")
  }),
};
